import { httpCreate } from './http';

const http = httpCreate('/srv/corp-info');

export const corpInfo = {
	setVisibleRange(activityId, body) {
		return http.post(`/setVisibleRange/${activityId}`, body);
	},
	getCorpInfo() {
		return http.get('/bound');
	},
	getCorpInfoOfActivity(acid) {
		return http.get(`/${acid}`);
	},
	getDepartmentUser(params) {
		return http.get('/user', { params });
	},
	syncCorpInfo(activityId = '', params) {
		return http.post(`/sync/${activityId}`);
	},
	cancel(activityId = '') {
		return http.post(`/cancel/${activityId}`);
	},
};
